import { ExcelExportColumnsDefinition } from "./excel-export-columns-definition.model";
import * as _ from 'lodash';

export class ExcelExportColumnsDefinitionConfig {
    private configurations: ExcelExportColumnsDefinition[];

    constructor(){
        this.configurations = [
            {
                key: 'LastName',
                displayName: 'Nom',
            },
            {
                key: 'FirstName',
                displayName: 'Prénom',
            },
            {
                key: 'Email',
                displayName: 'Email',
            }
        ]
    }

    public getColumnDefinitionKeys(): string[] {
        return this.configurations.map(config => config.key);
    }

    public getColumnDefinition(key: string): ExcelExportColumnsDefinition {
        return _.find(this.configurations, config => config.key.toLowerCase() === key.toLowerCase());
    }
}